<template>
	<div class="card" @click="detailHandle">
		<div class="card-base flex-center">
			<member-icon :icon="data.head_photo" :name="userName"></member-icon>
			<p class="title flex-grow ellipsis">{{userName}}_{{docName}}</p>
			<slot v-if="$scopedSlots.base_state" name="base_state"></slot>
			<c-state v-else dict="flowOrderStateDic" tag :value="docState"></c-state>
		</div>

		<div v-if="!viewStore" class="card-content">
			<template v-if="type == 7">
				<c-field label="单据编号">{{data.apply_code}}</c-field>
				<c-field label="计划使用时间">{{data.plan_use_time}}</c-field>
				<c-field label="预计归还时间">{{data.plan_return_time}}</c-field>
			</template>
			<template v-else-if="type == 9">
				<c-field label="单据编号">{{data.recruit_number}}</c-field>
				<c-field label="招工人数">{{data.recruit_count}}人</c-field>
				<c-field label="上班天数">{{data.work_days}}天</c-field>
			</template>
			<template v-else-if="type == 11">
				<c-field label="单据编号">{{data.document_number}}</c-field>
				<c-field label="报销类型"><c-state dict="reimbursementTypeDic" :value="data.reimbursement_type"></c-state></c-field>
				<c-field label="报销费用">￥{{data.total_amount}}</c-field>
			</template>
			<template v-else-if="type == 14">
				<c-field label="单据编号">{{data.document_number}}</c-field>
				<c-field label="加班类型"><c-state dict="overtimeTypeDic" :value="data.overtime_type"></c-state></c-field>
				<c-field label="加班时长">{{data.overtime_duration}}小时</c-field>
				<c-field label="加班事由">{{data.reason}}</c-field>
			</template>
		</div>
		<div v-else class="card-content">
			<c-field v-for="(field, j) in fieldList" :key="j" :label="field.field_title">
				<template v-if="$scopedSlots[field.field_code]">
					<slot :name="field.field_code"></slot>
				</template>
				<template v-else-if="field.is_custom">
					<div v-if="['file', 'image'].includes(data.customFieldValues[field.field_code].config_json.type)" class="flex-grow flex-wrap file-list">
						<template v-if="data.customFieldValues[field.field_code].value">
							<template v-if="typeof data.customFieldValues[field.field_code].value == 'string'">
								<c-file v-for="(item, i) in data.customFieldValues[field.field_code].value.split(',')" :key="i" :src="item" media :preview="data.customFieldValues[field.field_code].value.split(',')" @click.native.stop></c-file>
							</template>
							<template v-else>
								<c-file v-for="(item, i) in data.customFieldValues[field.field_code].value" :key="i" :src="item" media :preview="data.customFieldValues[field.field_code].value" @click.native.stop></c-file>
							</template>
						</template>
					</div>
					<c-tags v-else-if="typeof data.customFieldValues[field.field_code].value == 'object'" :value="data.customFieldValues[field.field_code].value"></c-tags>
					<span v-else>{{data.customFieldValues[field.field_code].value || '-'}}</span>
				</template>
				<template v-else>{{data[field.field_code] || '-'}}</template>
			</c-field>
		</div>
		<div class="card-button flex-end-center flex-wrap" @click.stop>
			<p v-if="data.executor_name" class="flex-grow" style="font-size: .26rem; color: #FF6900;">{{data.executor_name}} 处理中</p>
			<c-button @click="detailHandle">查看详情</c-button>
		</div>
	</div>
</template>

<script>
	import {getStore, mapStore} from '@deanwu/vue-component-library-mobile'

	export default {
		name: 'viewDocCard',

		props: {
			type: [Number, String],
			data: Object
		},

		data() {
			return {
				...getStore(this, 'viewStore')
			}
		},
		
		computed: {
			...mapStore('viewStore', ['fieldList']),

			docName() {
				return {
					7: '资产领用单',
					9: '外协招工申请',
					11: '费用报销申请',
					12: '请假单',
					13: '资产归还单',
					14: '加班申请',
					16: '资产维修记录'
				}[this.type];
			},
			
			docState() {
				return this.data.status || this.data.apply_status;
			},

			userName() {
				return this.data.create_user_realname || this.data.apply_user_name || this.data.create_user_name;
			}
		},

		methods: {
			detailHandle() {
				let path = {
					7: '/assets/receive/detail',
					9: '/aftersales/outsource/detail',
					11: '/finance/reimb/detail',
					12: '/affairs/leave/detail',
					13: '/assets/return/detail',
					14: '/affairs/overtime/detail',
					16: '/assets/repair/detail'
				}[this.type];
				path && this.mp.navigateWeb(path, {id: this.data.id});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.card {
		border-radius: .16rem;
		padding: .24rem .26rem;
		margin: 0 .24rem;
		background: #fff;

		&-base {
			gap: .2rem;
			margin-bottom: .2rem;

			.title {
				font-weight: 500;
				font-size: .32rem;
				color: #333;
			}
		}

		&-content {
			>>> .c-field {
				line-height: .38rem;
				font-size: .26rem;
				color: #666;

				&:nth-child(n+2) {
					margin-top: .06rem;
				}
			}
		}

		&-button {
			gap: .2rem;
			margin-top: .2rem;
		}
	}
</style>
